import React, { useState, useEffect } from 'react';
import ReactApexChart from 'react-apexcharts';
import useReactApexChart from '../../hook/useReactApexChart';
import { useAuth } from '../../context/AuthContext';
import config from '../../config';

const UsersOverviewOne = ({ className = "col-xxl-4 col-xl-5 col-12" }) => {
    let { donutChartSeries, donutChartOptions } = useReactApexChart();
    const { auth } = useAuth();
    const [series, setSeries] = useState(donutChartSeries);
    const [newUsers, setNewUsers] = useState(0);
    const [subscribedUsers, setSubscribedUsers] = useState(0);
    const [range, setRange] = useState('Today');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await auth.fetch(`${config.API_BASE_URL}/api/users/overview?range=${range}`);
                if (response.ok) {
                    const data = await response.json();
                    setSeries([data.new_users, data.subscribed_users]);
                    setNewUsers(data.new_users);
                    setSubscribedUsers(data.subscribed_users);
                }
            } catch (error) {
                console.error('Failed to fetch user overview:', error);
            }
        };

        fetchData();
    }, [range, auth]);

    const totalUsers = (newUsers || 0) + (subscribedUsers || 0);
    const chartSeries = totalUsers > 0 ? series : [1];
    const chartOptions = {
        ...donutChartOptions,
        colors: totalUsers > 0 ? ["#487FFF", "#FF9F29"] : ["#E2E8F0"],
        labels: totalUsers > 0 ? ["New", "Subscribed"] : ["No Activity"],
        tooltip: {
            enabled: totalUsers > 0
        },
        plotOptions: {
            pie: {
                donut: {
                    size: '72%',
                    labels: {
                        show: true,
                        name: { show: false },
                        value: {
                            show: true,
                            fontSize: '22px',
                            fontWeight: '600',
                            color: '#64748B',
                            formatter: () => totalUsers.toLocaleString()
                        },
                        total: {
                            show: true,
                            label: '',
                            formatter: () => totalUsers.toLocaleString()
                        }
                    }
                }
            }
        }
    };

    return (
        <div className={className}>
            <div className="card h-100 radius-8 border-0 overflow-hidden">
                <div className="card-body p-24">
                    <div className="d-flex align-items-center flex-wrap gap-2 justify-content-between">
                        <h6 className="mb-2 fw-bold text-lg">User Growth</h6>
                        <div className="">
                            <select 
                                className="form-select form-select-sm w-auto bg-base border text-secondary-light" 
                                value={range}
                                onChange={(e) => setRange(e.target.value)}
                            >
                                <option value="Today">Today</option>
                                <option value="Weekly">Weekly</option>
                                <option value="Monthly">Monthly</option>
                                <option value="Yearly">Yearly</option>
                            </select>
                        </div>
                    </div>
                    <ReactApexChart options={chartOptions} series={chartSeries} type="donut" height={264} />
                    <ul className="d-flex flex-wrap align-items-center justify-content-between mt-3 gap-3">
                        <li className="d-flex align-items-center gap-2">
                            <span className="w-12-px h-12-px radius-2 bg-primary-600" />
                            <span className="text-secondary-light text-sm fw-normal">
                                New:
                                <span className="text-primary-light fw-semibold ms-1">{newUsers.toLocaleString()}</span>
                            </span>
                        </li>
                        <li className="d-flex align-items-center gap-2">
                            <span className="w-12-px h-12-px radius-2 bg-yellow" />
                            <span className="text-secondary-light text-sm fw-normal">
                                Subscribed:
                                <span className="text-primary-light fw-semibold ms-1">{subscribedUsers.toLocaleString()}</span>
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default UsersOverviewOne;